import {Avatar, Button, Modal} from 'antd'
import {course_getTeacherById_Api, course_getTeachers_Api, teacherSchema,} from 'apis'
import {getId} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import Async from 'modules/asyncCache/components/Async'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {TeacherActionTypes} from 'views/AppLocals/Course'
import {CreateTeacherModal, EditTeacherModal,} from 'views/AppLocals/Course/Teacher/TeacherForm'
import {useTeacher} from 'views/AppLocals/Course/Teacher/useTeacher'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParam, bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import {renderTeacher} from '../functions/renderTeacher'
import {RiSearchEyeLine} from "react-icons/ri";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {HeaderWithIconLine} from "../../../AppLocals/Templates/items/ListHeader";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import getAvatar from "../../../../helpers/getAvatar";
import {renderIf, renderIfElse} from "../../../Shared";
import TeacherFilter from "../components/filters/TeacherFilter";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {FaLink, FaUserTie} from "react-icons/fa6";
import {BsInfoCircleFill} from "react-icons/bs";
import {MdContactPhone} from "react-icons/md";
import {PiListNumbersBold} from "react-icons/pi";
import {NoImage} from "../../../../conts/imageBase64";
import ImageLoader from "../../../../components/ImageLoader";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getAliasName from "../../../../helpers/getAliasName";
import getTitle from "../../../../helpers/getTitle";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import LoadingBlock from "../../../LoadingBlock";
import {SectionTemplate} from "../../Workspace";
import classNames from "classnames";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";

const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const Teachers = ({
                      owner_id, owner_type,
                      Wrapper = 'div',
                      hashtagsFilter = '',
                      filter_actions = {
                          sortBy: 'sort-by',
                          keyword: 'keyword',
                          hashtags: 'hashtags',
                      }
                  }) => {
    const t = useTranslate()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const hashtags = useRouteSearchParam(filter_actions.hashtags) || hashtagsFilter;

    const onCancel = () => {
        setAction({})
    }

    const {
        refreshKey,
        onCreate = NullAsDefault,
        onUpdate = NullAsDefault,
        onDelete = NullAsDefault,
    } = useTeacher({
        onCreated: onCancel,
        onUpdated: onCancel,
        onDeleted: onCancel,
    })

    const confirmDelete = useCallback(
        (id) => {
            if (id) {
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete teacher',
                    message: 'are you sure you want to delete it teacher',
                    onOk: () => {
                        onDelete({}, {id})
                    },
                })
            }
        },
        [onDelete]
    )

    const handleAction = (action, params) => {
        switch (action) {
            case TeacherActionTypes.TEACHER_READ:
            case TeacherActionTypes.TEACHER_UPDATE:
            case TeacherActionTypes.TEACHER_CREATE:
                setAction({type: action, value: params})
                break
            case TeacherActionTypes.TEACHER_DELETE:
                confirmDelete(params?.id)
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-green-600"/>,
                        label: 'view detail',
                        key: TeacherActionTypes.TEACHER_READ,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: TeacherActionTypes.TEACHER_UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: TeacherActionTypes.TEACHER_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )


    const DetailTeacherContent = ({item}) => {
        const t = useTranslate()
        const {
            user,
            avatar,
            fullname,
            teacher_idcode,
            date_of_birth,
            prefix_title,
            gender,
            place_of_birth,
            contact_phone,
            contact_email,
            contact_address,
            majors,
            fields,
            experiences,
            degrees,
            hashtags = "",
            edit,
        } = item ?? {}

        const tags = (hashtags || "").split(",").filter(e => !!e);

        return (
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                        title="teacher information"
                        className="text-sm text-color-400"
                    />
                    <div className="flex gap-3">
                        <ImageLoader
                            style={{width: isSm ? 100 : 130, height: isSm ? 100 : 130}}
                            src={avatar || getAvatar(user) || NoImage}
                            fallback={NoImage}
                            className="background-200 rounded-lg object-cover mt-1"
                        />
                        <div className="flex flex-col flex-1 gap-1">
                            <ItemInformation primary={true} showIcon={true} label={!isSm && "full name"}
                                             value={`${prefix_title} ${fullname}`} className="text-sm"/>
                            <ItemInformation showIcon={true} label="teacher code" value={`#${teacher_idcode}`}
                                             className="text-xs italic"/>
                            {renderIf(
                                gender !== 0,
                                <ItemInformation showIcon={true} label={!isSm && "gender"}
                                                 value={t(getLabelOfGender(gender))} className="text-xs italic"/>
                            )}
                            {renderIf(
                                _.some([date_of_birth, place_of_birth]),
                                <DoubleValueItem
                                    showIcon={true}
                                    labelFirst={!isSm && "date of birth"}
                                    valueFirst={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                                    labelSecond={place_of_birth ? ' - ' : ''}
                                    valueSecond={place_of_birth}
                                    className="text-xs italic"
                                />
                            )}
                            {renderIf(
                                tags.length > 0,
                                <div className="flex flex-wrap gap-2 mt-1 md:mt-2">
                                    {tags.map((ee, ii) => (
                                        <span key={ii}
                                              style={{
                                                  width: 'fit',
                                                  height: isSm ? 17 : 20,
                                                  padding: isSm ? '0 8px' : '1px 8px',
                                                  fontSize: isSm ? 9 : 11,
                                                  borderRadius: 999
                                              }}
                                              className="flex flex-center border border-primary-300 font-medium text-primary-500 italic leading-tight">
                              {ee}
                          </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {renderIf(
                    user,
                    <div className="flex flex-col gap-1">
                <span className="text-xs text-color-500 italic">
                  <FaLink size={10} className="mr-1 text-color-400"/>
                    {`${t('link account')} : `}
                </span>
                        <div className="ml-2 flex items-center gap-3">
                            <Avatar
                                size={36}
                                src={getAvatar(user)}
                                icon={<FaUserTie size={18} className="text-color-500"/>}
                                className="flex flex-center background-200"
                            />
                            <div className="flex flex-col">
                    <span className="text-xs text-color-500 italic leading-tight">
                        {`${t('account name')} : `}
                    </span>
                                {renderIfElse(
                                    edit === true,
                                    <Link target="_blank" to={getLinkToDetail(user)}
                                          className="font-medium text-primary-700 no-underline leading-snug">
                                        {getAliasName(user, 'patron_saint')}
                                        {` ${getTitle(user)}`}
                                    </Link>,
                                    <span className="font-medium text-primary-700 leading-snug">
                          {getAliasName(user, 'patron_saint')}
                                        {getTitle(user)}
                        </span>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        icon={<MdContactPhone size={14} className="text-color-500 mr-1"/>}
                        title="contact information"
                        className="text-sm text-color-400"
                    />
                    <div className="ml-0 md:ml-1 flex flex-col gap-1">
                        <ItemInformation showIcon={true} label="phone" value={contact_phone}
                                         className="text-xs italic"/>
                        <ItemInformation showIcon={true} label="email" value={contact_email}
                                         className="text-xs italic"/>
                        <ItemInformation showIcon={true} label="address" value={contact_address}
                                         className="text-xs italic"/>
                    </div>
                </div>
                {renderIf(
                    _.some([majors, fields, experiences, degrees]),
                    <div className="flex flex-col gap-2">
                        <HeaderWithIconLine
                            icon={<PiListNumbersBold size={14} className="text-color-500 mr-1"/>}
                            title="education level"
                            className="text-sm text-color-400"
                        />
                        <div className="ml-0 md:ml-1 flex flex-col gap-1">
                            <ItemInformation showIcon={true} label="degrees" value={degrees}
                                             className="text-xs italic"/>
                            <ItemInformation showIcon={true} label="experiences" value={experiences}
                                             className="text-xs italic"/>
                            <ItemInformation showIcon={true} label="fields" value={fields} className="text-xs italic"/>
                            <ItemInformation showIcon={true} label="majors" value={majors} className="text-xs italic"/>
                        </div>
                    </div>
                )}
                <div className="p-3 text-right">
            <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
              {t('close')}
            </span>
                </div>
            </div>
        )
    }

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {fullname: undefined}
        let modal_params = {}
        switch (action?.type) {
            case TeacherActionTypes.TEACHER_READ:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('view teacher information')}
                    </div>
                )
                params = {item: action?.value}
                modal_params = {
                    width: 640,
                }
                Content = DetailTeacherContent
                break
            case TeacherActionTypes.TEACHER_CREATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('create teacher')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCreate(values, {
                            id: owner_id,
                            type: owner_type,
                        })
                    },
                }
                modal_params = {
                    width: 720,
                }
                Content = CreateTeacherModal
                break
            case TeacherActionTypes.TEACHER_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('update teacher')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                modal_params = {
                    width: 800,
                }
                Content = ({initialValues, ...rest}) => (
                    <SelectEntityItem
                        schema={teacherSchema}
                        item={getId(initialValues)}
                        defaultItem={initialValues}>
                        {(item) => (
                            <EditTeacherModal
                                {...rest}
                                initialValues={item}
                            />
                        )}
                    </SelectEntityItem>
                )
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: course_getTeacherById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            hashtags,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, hashtags, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            hashtagsFilter
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                hashtags: hashtags,
            })
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            PaginationMeta: renderGridMeta,
            renderItem: renderTeacher({
                renderContextMenu,
                handleAction: (type, value) => {
                    setAction({type, value});
                }
            }),
            apiInfo: course_getTeachers_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),

            renderWrap: (child, __, count) => !!count
                ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {child}
                    </div>
                )
                : (
                    <div className="flex flex-col gap-6">
                        {child}
                    </div>
                ),
        },
        withValues: (values) => ({
            ...values,
            hashtags: !!hashtags ? hashtags : hashtagsFilter,
        }),
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        query_params: filter_actions,
        isToggleDefault: true,
        AdvancedFilter: TeacherFilter,
        dependencies: [owner_id, owner_type, hashtagsFilter],
        withKey: createPagerKey(refresh_deps),
    })
    return (
        <Wrapper className="flex flex-1 flex-col space-y-3">

            <SectionTemplate
                title={t("teacher staff management")}
                description={t("manage teacher profiles assign roles admin lecturer teaching assistant and track teaching performance")}
                actionText={t("add new staff")}
                renderActionButton={() => (
                    <Button
                        type="primary"
                        className="mt-6 px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-600 transition"
                        onClick={() => {
                            handleAction(TeacherActionTypes.TEACHER_CREATE)
                        }}>
                        {t("add new staff")}
                    </Button>
                )}
            />
            {pager_widget}
            {modal}
        </Wrapper>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(Teachers)
